import axios from "axios";

export default {
  getAll(accessToken,page, broj_projekta, start_date, end_date, isArchived) {
    try {
      return axios.get("https://app-psod.cratis.cloud/projects", {
        params: {
          token: accessToken,
          page,
          broj_projekta,
          start_date,
          end_date,
          isArchived
        },
        credentials: true,
      });
    } catch {
      console.log("Failed attempt at group.");
    }
  },
  searchProjects(srch_txt) {
    try {
      return axios.get("https://app-psod.cratis.cloud/projects/search", {
        params: {
          srch_txt
        },
        credentials: true,
      });
    } catch {
      console.log("Failed attempt at search.");
    }
  },
  getAllFilteri() {
    try {
      return axios.get("https://app-psod.cratis.cloud/predmeti/filteri", {
        params: {},
        credentials: true,
      });
    } catch {
      console.log("Failed attempt at group.");
    }
  },
  getAllPhases() {
    try {
      return axios.get("https://app-psod.cratis.cloud/predmeti/filteri/faze", {
        params: {},
        credentials: true,
      });
    } catch {
      console.log("Failed attempt at group.");
    }
  },
  getCaseTeam(predmetId) {
    try {
      return axios.get("https://app-psod.cratis.cloud/predmeti/"+predmetId+"/team", {
        credentials: true,
      });
    } catch {
      console.log("Failed attempt at group.");
    }
  },
  getCaseTeamShort(predmetId) {
    try {
      return axios.get("https://app-psod.cratis.cloud/predmeti/"+predmetId+"/team_short", {
        credentials: true,
      });
    } catch {
      console.log("Failed attempt at group.");
    }
  },
  getAllPostupci() {
    try {
      return axios.get("https://app-psod.cratis.cloud/predmeti/postupci", {
        params: {},
        credentials: true,
      });
    } catch {
      console.log("Failed attempt at group.");
    }
  },
  getAllBrojevi() {
    try {
      return axios.get("https://app-psod.cratis.cloud/projects/next-num", {
        credentials: true,
      });
    } catch {
      console.log("Failed attempt at group.");
    }
  },
  getUserProjectPermission(projectId, user_id) {
    try {
      return axios.get("https://app-psod.cratis.cloud/projects/"+projectId+"/permissions", {
        params: {
          user_id : user_id
        },
        credentials: true,
      });
    } catch {
      console.log("Failed attempt at group.");
    }
  },

  getSingle(predmetId) {
    try {
      return axios.get("https://app-psod.cratis.cloud/projects/"+predmetId, {
        credentials: true,
      });
    } catch {
      console.log("Failed attempt at group.");
    }
  },
  addProject(unos_projekta, access_token,logged_uid) {
    try {
      return axios.post("https://app-psod.cratis.cloud/projects/", {
        params: {
          unos_projekta,
          access_token,
          logged_uid
        },
        credentials: true,
      });
    } catch {
      console.log("Failed attempt at group.");
    }
  },
  updateProject(unos_projekta, access_token,project_id, logged_uid) {
    try {
      return axios.put("https://app-psod.cratis.cloud/projects/"+project_id, {
        params: {
          unos_projekta,
          access_token,
          logged_uid
        },
        credentials: true,
      });
    } catch {
      console.log("Failed attempt at group.");
    }
  },


  // NAPOMENE START
  addPredmetNapomena(napomena,group_url) {
    try {
      return axios.post("https://app-psod.cratis.cloud/predmeti/"+group_url+"/napomene", {
        params: {
          napomena
        },
        credentials: true,
      });
    } catch {
      console.log("Failed attempt at group.");
    }
  },
  getPredmetNapomene(group_url) {
    try {
      return axios.get("https://app-psod.cratis.cloud/predmeti/"+group_url+"/napomene");
    } catch {
      console.log("Failed attempt at group.");
    }
  },
  addNewProjectTask(project_task) {
    try {
      return axios.post("https://app-psod.cratis.cloud/projects/project-task", project_task, {
        credentials: true,
      });
    } catch {
      console.log("Failed attempt at group.");
    }
  },
  updateProjectTask(project_task) {
    try {
      return axios.post("https://app-psod.cratis.cloud/projects/update-project-task", project_task, {
        credentials: true,
      });
    } catch {
      console.log("Failed attempt at group.");
    }
  },
  updateProjectProgress(event_uid, status_id, team_list, case_uid, is_case) {
    try {
      return axios.post("https://app-psod.cratis.cloud/projects/update-status", {
        params: {
          event_uid,
          status_id,
          team_list,
          case_uid,
          is_case,
        },
        credentials: true,
      });
    } catch {
      console.log("Failed attempt at group.");
    }
  },
  getProjectTasks(group_url) {
    try {
      return axios.get("https://app-psod.cratis.cloud/projects/"+group_url+"/tasks");
    } catch {
      console.log("Failed attempt at group.");
    }
  },
  deleteTask(access_token, task_uid, team_list, case_uid, attachments, group_uid, is_case) {
    try {
      return axios.delete("https://app-psod.cratis.cloud/projects/project-task/", {
        params: {
          task_uid,
          access_token,
          team_list,
          case_uid,
          attachments,
          group_uid,
          is_case,
        },
        credentials: true,
      });
    } catch {
      console.log("Failed attempt at group.");
    }
  },
  getTaskAttachment(accessToken,group_url,attachment_id){
    try {
      return axios.get("https://app-psod.cratis.cloud/projects/task-attachment/existing-attachment", {
        params: {
          token: accessToken,
          group_url : group_url,
          attachment_id : attachment_id,
        },
        credentials: true,
      });
    } catch {
      console.log("Failed attempt at group.");
    }
  },
  // NAPOMENE END


  // MESSAGES START
  
  get_project_messages(group_url){
    try {
      return axios.get("https://app-psod.cratis.cloud/projects/"+group_url+"/messages", {
        params: {
          group_url : group_url,
        },
        credentials: true,
      });
    } catch {
      console.log("Failed attempt at group.");
    }
  },
  send_project_message(group_url, new_message, list_of_users){
    try {
      return axios.post("https://app-psod.cratis.cloud/projects/"+group_url+"/messages", {
        params: {
          new_message,
          list_of_users
        },
        credentials: true,
      });
    } catch {
      console.log("Failed attempt at group.");
    }
  },
  // MESSAGES END
  openProject(proj_id) {
    try {
      return axios.post("https://app-psod.cratis.cloud/projects/"+proj_id+"/open", {
        credentials: true,
      });
    } catch {
      console.log("Failed attempt at group.");
    }
  },
  closeProject(proj_id, datum_arhiviranja) {
    try {
      return axios.post("https://app-psod.cratis.cloud/projects/"+proj_id+"/close", {
        params:{
          datum_arhiviranja
        },
        credentials: true,
      });
    } catch {
      console.log("Failed attempt at group.");
    }
  },
};
